export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-video/_content-section-video.twig";